<template>
  <div>
    <div class="text-center">
      <span class="mb-0 text-center text-capitalize-first">{{ helper.trans('labels.matching_pay_in_deals')}}</span>
    </div>

    <table class="table table-striped border-light align-middle">
      <thead>
      <tr>
        <th></th>
        <th class="text-capitalize-first">{{ helper.trans('labels.id_date') }}</th>
        <th class="text-capitalize-first">{{ helper.trans('labels.type')}}</th>
        <th class="text-capitalize-first">{{ helper.trans('labels.status')}}</th>
        <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="deal in deals.items" :key="deal.id">
        <td>
          <PayMethodIcon :method="deal.paymentMethod"></PayMethodIcon>
        </td>
        <td>
          <div class="d-flex flex-column">
                          <span>
                            <span :title="deal.publicId">{{ deal.publicId }}</span> <copy-button :value="deal.publicId"></copy-button>
                          </span>
            <small class="text-secondary">{{ dateHelper.format(deal.createdAt) }}</small>
          </div>
        </td>
        <td>
          {{ helper.trans(`direction.${deal.type}`) }}
        </td>
        <td :class="{'text-primary': deal.status === DealStatus.TRANSFER_CONFIRMED}">
          {{ helper.trans(`deal_status.${deal.status}`) }}
          <a v-for="attachment in deal.attachments" :key="attachment.id" :href="`${api.baseUrl()}/attachments/${attachment.file}`" target="_blank" type="button" class="me-2 text-warning"><i class="fa fa-paperclip"></i></a>
        </td>
        <td>
          <div class="">
            {{ numberFormatter.formatMoney(deal.takerSum) }}
            <copy-button :value="deal.takerSum.amount"></copy-button>
          </div>
          <div class="small  text-secondary">
            {{ numberFormatter.formatMoney(deal.makerSum) }}
            <copy-button :value="deal.makerSum.amount"></copy-button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType, reactive, ref, toRefs} from 'vue'
import {helper} from "@/service/CommonHelper";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TraderDealDTO from "@/models/TraderDealDTO";
import {api} from "@/service/APIClient";
import OrderByDTO from "@/models/OrderByDTO";
import DealRequestDTO from "@/models/request/DealRequestDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {DealStatus} from "@/models/enum/DealStatus";

export default defineComponent({
  components: {
    PayMethodIcon,
    CopyButton,
  },
  props: {
    dealId: {
      type: Object as PropType<string>,
      required: true
    } as Prop<string>
  },
  setup(props) {

    const state = reactive({
      page: 1,
      deals: {
        limit:100,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<TraderDealDTO>
    });


    const load = async () => {
      if (!props.dealId) {
        return;
      }

      state.deals.offset = state.deals.limit * (state.page - 1)
      state.deals = await api.deals(state.deals, {
        field: 'createdAt',
        direction: 'desc',
      } as OrderByDTO, {matchingPayOutDealId: props.dealId} as unknown as DealRequestDTO);
    }

    onMounted(() => {
      load()
    });

    return {
      ...toRefs(state),
      dateHelper,
      numberFormatter,
      helper,
      DealStatus
    }
  }
})
</script>
